import React, { Fragment, useRef, useState, useEffect } from 'react';
import { slugify } from '@utils';
import { motion, AnimatePresence } from 'framer-motion';
import { gsap } from 'gsap';

const Question = ({ value, title, options, handleSelection }) => {
  const disabledOptions = ['Coily'];



  const handleKeyUp = (e) => {
    if (e.keyCode === 13) {
      e.target.click()
    }
  }

  const renderLabelSingle = (value, option) => {
    const [showPopup, setShowPopup] = useState(null);
    const popupTl = useRef(null)
    const popup = useRef(null)

    useEffect(() => {
      popupTl.current = gsap.timeline({ paused: true })
        .to(popup.current, { opacity: 1, display: "block", top: "50%" })

      return popupTl.current.kill()
    }, [])

    useEffect(() => {
      showPopup ? popupTl.current.play() : popupTl.current.reverse()
    }, [showPopup])

    return (
      <Fragment key={slugify(option)}>
        <label htmlFor={value + '-' + slugify(option)} tabIndex="0" onKeyUp={handleKeyUp} onClick={e => disabledOptions.includes(option) ? setShowPopup(true) : null}>
          <input
            type="radio"
            id={value + '-' + slugify(option)}
            name={value}
            defaultChecked={false}
            disabled={disabledOptions.includes(option) ? true : false}
            onChange={handleSelection}
            value={option} />
          <div className="inner">
            <figure className="Media__content">
              <img
                src={`${window.__webpack_public_path__}${value}-${slugify(option)}.png`}
                loading="lazy"
                alt={option} />
            </figure>
            <span className="caption">{option}</span>
          </div>
        </label>
        {disabledOptions.includes(option) &&
          <div className="DisabledOptionPopup" ref={popup}>
            <button type="button" className="Button" data-layout="noLayout" onClick={(e) => setShowPopup(false)}>
              <svg viewBox='0 0 20 20' className='icon' width='1em' height='1em'>
                <use href='#close'></use>
              </svg>
            </button>
            At this time we do not offer <strong>{option} Extensions</strong>. Check back in as we are always looking to expand. We would love to hear from you, email <a href="mailto:contact@bfbhair.com">contact@bfbhair.com</a> with your recommendations!
          </div>
        }
      </Fragment>
    )
  }

  const renderLabelMultiple = (value, options) => {
    return (
      <>
        {options.map(option => {
          if (option == 'Mostly Down') {
            return (
              <label htmlFor={value + '-' + slugify(option)} key={slugify(option)} tabIndex="0" onKeyUp={handleKeyUp} key={value + '-' + slugify(option)}>
                <input
                  type="checkbox"
                  id={value + '-' + slugify(option)}
                  name={value}
                  defaultChecked={false}
                  onChange={handleSelection}
                  value={option} />
                <div className="inner">
                  <figure className="Media__content">
                    <img
                      src={`${window.__webpack_public_path__}${value}-${slugify(option)}.png`}
                      loading="lazy"
                      alt={option} />
                  </figure>
                  <span className="caption">{option}</span>
                  <span className="faux-checkbox"></span>
                </div>
              </label>
            )
          } else {
            return (
              <label htmlFor={value + '-' + slugify(option)} key={slugify(option)} tabIndex="0" onKeyUp={handleKeyUp} key={value + '-' + slugify(option)}>
                <input
                  type="checkbox"
                  id={value + '-' + slugify(option)}
                  name={value}
                  defaultChecked={false}
                  onChange={handleSelection}
                  value={option} />
                <div className="inner">
                  <div className="mediaWrapper">
                    {option.split(',').map((opt, index) => (
                      <figure className="Media__content" key={value + '-' + slugify(option) + "-image" + index}>
                        <img
                          src={`${window.__webpack_public_path__}${value}-${slugify(opt)}.png`}
                          loading="lazy"
                          alt={opt} />
                      </figure>
                    ))}
                  </div>
                  <span className="caption">{option}</span>
                  <span className="faux-checkbox"></span>
                </div>
              </label>
            )
          }
        })}
      </>
    )
  }

  return (
    <div className="Section Section--question" data-question={value}>
      <div className="Section__header">
        <h4 className="heading">{title}</h4>
        {value == 'plan' && <p className="info big">Select all that apply.</p>}
        {value == 'goals' && <p className="info">Note: "Volume & Length" will show the same product as "Length"</p>}
      </div>
      <div className="Section__content Media">
        {value == 'plan'
          ? renderLabelMultiple(value, options)
          : options.map(option => renderLabelSingle(value, option))
        }
      </div>
    </div>
  )
}

export default Question;